import React from 'react';

const LoadingModal = ({ isOpen, message }) => {
  if (!isOpen) return null;

  return (
    <div className="loading-modal-backdrop" role="dialog" aria-modal="true" aria-label="Loading protocol">
      <div className="loading-modal">
        <div className="loading-modal-spinner" aria-hidden="true" />
        <p>{message}</p>
      </div>
    </div>
  );
};

export default LoadingModal;
